<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>消息</el-breadcrumb-item>
          <el-breadcrumb-item>发件箱</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">订单编号:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.orderId" size="small"
                  @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">客户ID:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.remindingUserName" size="small"
                  @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">员工ID:</div>
              <div class="flex1">
                <el-input placeholder="请输入内容" clearable v-model="queryInfo.createUserName" size="small"
                  @keyup.enter.native="searchList">
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">类型:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.messageType" placeholder="请选择" size="small" clearable>
                  <el-option v-for="(item, index) in messageTypeOptions" :key="'key1' + index" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">发送开始日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">发送结束日:</div>
              <div class="flex1">
                <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择日期">
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">消息状态:</div>
              <div class="flex1">
                <el-select v-model="queryInfo.status" placeholder="请选择" size="small" clearable>
                  <el-option
                      v-for="item in messageStatusList"
                      :key="item.data"
                      :label="item.name"
                      :value="item.data">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <div class="query-title">标题:</div>
            <div class="flex1">
              <el-input placeholder="请输入标题" clearable v-model="queryInfo.remindingTitle" size="small"
                v-on:click.self="searchList" @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="6" class="display-row">
            <div class="query-title">内容:</div>
            <div class="flex1">
              <el-input placeholder="请输入内容" clearable v-model="queryInfo.remindingContent" size="small"
                v-on:click.self="searchList" @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>

          <el-col :span="12" class="display-row">
            <div style="text-align:right;width:100%;padding-right:10px;float:right">
              <el-button class="search-btn btn-gray" @click="queryInfoClear">重置</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">搜索</el-button>
              <el-button class="search-btn btn-blue" @click="exportAction">导出</el-button>
              <el-button class="search-btn btn-blue" v-if="!isActive" type="primary" icon="el-icon-arrow-down" alt=""
                @click="isActive = !isActive">展开</el-button>
              <el-button class="search-btn btn-green" v-if="isActive" icon="el-icon-arrow-up" alt=""
                @click="isActive = !isActive">收起</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="messageList"
          border height="550">
          <el-table-column type="index" align="center" label="序号" width="40" fixed></el-table-column>
          <el-table-column label="操作" align="center" width="80" fixed>
            <template v-slot="scope">
              <div class="btn-row">
                <el-button class="list-btn btn-blue" @click="handleDetail(scope.row)">
                  详情
                </el-button>
                <el-button class="list-btn btn-gray" @click="revoke(scope.row)">
                  撤回
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="messageType" align="center" label="消息类型">
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.messageType) }}
            </template>
          </el-table-column>
          <el-table-column prop="status" :index="indexMethod" sortable width="100" align="center" label="已读状态">
            <template v-slot="scope">
              {{ getMessageStatus(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column prop="orderId" width="200" align="center" label="订单编号">
            <template v-slot="scope">
              <el-link @click="toOrderDetail(scope.row)" :underline="false">{{ scope.row.orderId }}</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="remindingTitle" align="center" width="200" label="标题">
          </el-table-column>
          <el-table-column label="内容" width="200">
            <template v-slot="scope">
              <div v-html="scope.row.remindingContent"></div>
            </template>
          </el-table-column>
          <el-table-column width="250" prop="replyPicture" label="图片">
            <template slot-scope="scope">
              <el-row :gutter="12">
                <el-col :span="8" v-for="(item, index) in getFileList(scope.row.replyPicture)" :key="'key3' + index">
                  <img @click="imgclick(item, true)" v-if="item && item.length > 0" :src="item" alt=""
                    class="list-image more-image">
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column width="150" prop="video" label="mp4">
            <template slot-scope="scope">
              <video width="100%" height="auto" controls v-if="scope.row.video">
                <source :src="scope.row.video" type="video/mp4" />
                您的浏览器不支持Video标签。
              </video>
            </template>
          </el-table-column>
          <el-table-column width="200" label="附件">
            <template v-slot="scope">
              <span v-for="(item, index) in getAttachment(scope.row.attachment)" :key="'key4' + index">
                <a target="_blank" :href="item.url">{{ item.name }}</a><br />
              </span>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="createUserName" label="员工ID" align="center">
          </el-table-column>
          <el-table-column width="100" prop="remindingUserName" label="客户ID" align="center">
          </el-table-column>
          <el-table-column prop="createTime" align="center" sortable :index="indexMethod" width="200" label="发送日">
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum" :page-sizes="[5, 10, 20, 50, 100, 200]" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </table-con>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="信息详情" :visible.sync="detailFlag" width="1400px">
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="firstList" border>
        <el-table-column width="100" prop="replyFlag" :index="indexMethod" sortable label="消息状态" align="center">
          <template v-slot="scope">
            {{ getMessageStatus(scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column width="250" prop="replyPicture" label="图片">
          <template slot-scope="scope">
            <el-row :gutter="12">
              <el-col :span="8" v-for="(item, index) in getFileList(scope.row.replyPicture)" :key="'key5' + index">
                <img @click="imgclick(item, true)" v-if="item && item.length > 0" :src="item" alt=""
                  class="list-image more-image">
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column width="150" prop="video" label="mp4">
            <template slot-scope="scope">
              <video width="100%" height="auto" controls v-if="scope.row.video">
                <source :src="scope.row.video" type="video/mp4" />
                您的浏览器不支持Video标签。
              </video>
            </template>
          </el-table-column>
        <el-table-column prop="messageType" align="center" label="类型">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" label="订单编号">
          <template v-slot="scope">
            <el-link @click="toOrderDetail(scope.row)" :underline="false">{{ scope.row.orderId }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="用户ID">
          <template v-slot="scope">
            {{ scope.row.createUserName === 'system' ? "" : scope.row.createUserName }}
          </template>
        </el-table-column>
        <el-table-column prop="createTime" width="200" sortable :index="indexMethod" align="center" label="发送日">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column width="200" prop="remindingTitle" align="center" label="标题">
        </el-table-column>
        <el-table-column width="300" prop="remindingContent" label="内容">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" label="附件">
          <template v-slot="scope">
            <span v-for="(item, index) in getAttachment(scope.row.attachment)" :key="'key6' + index">
              <a target="_blank" :href="item.url">{{ item.name }}</a><br />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="title">历史对话</div>
      <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="historyMessageList"
        border height="550px">
        <el-table-column label="发件人" prop="sender" align="center">
          <template v-slot="scope">
            <div v-if="scope.row.sender == 1">平台</div>
            <div v-if="scope.row.sender == 0">客户</div>
          </template>
        </el-table-column>
        <el-table-column prop="replyFlag" :index="indexMethod" sortable label="消息状态" align="center">
          <template v-slot="scope">
           {{ getMessageStatus(scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" label="图片" width="250">
          <template slot-scope="scope">
            <el-row :gutter="12">
              <el-col :span="8" v-for="(item, index) in getFileList(scope.row.replyPicture)" :key="'key7' + index">
                <img @click="imgclick(item, true)" v-if="item && item.length > 0" :src="item" alt=""
                  class="list-image more-image">
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column width="150" prop="video" label="mp4">
            <template slot-scope="scope">
              <video width="100%" height="auto" controls v-if="scope.row.video">
                <source :src="scope.row.video" type="video/mp4" />
                您的浏览器不支持Video标签。
              </video>
            </template>
          </el-table-column>
        <el-table-column prop="messageType" align="center" label="类型">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" label="订单编号">
          <template v-slot="scope">
            <el-link @click="toOrderDetail(scope.row)" :underline="false">{{ scope.row.orderId }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="用户ID">
          <template v-slot="scope">
            {{ scope.row.createUserName === 'system' ? "" : scope.row.createUserName }}
          </template>
        </el-table-column>
        <el-table-column width="200" prop="createTime" sortable :index="indexMethod" align="center" label="发送日">
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column width="200" prop="remindingTitle" align="center" label="标题">
        </el-table-column>
        <el-table-column width="300" prop="remindingContent" label="内容">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" label="附件">
          <template v-slot="scope">
            <span v-for="(item, index) in getAttachment(scope.row.attachment)" :key="'key8' + index">
              <a target="_blank" :href="item.url">{{ item.name }}</a><br />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align:right;margin-top:15px">
        <el-button class="form-btn btn-blue" @click="detailFlag = false">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from '../../views/tableContainer'
import Oss from "../../assets/js/oss";

export default {
  components: { tableCon },
  data() {
    return {
      isActive: false,
      visible: false,
      imgurl: '',
      detailFlag: false,
      firstList: [],
      historyMessageList: [],
      messageStatusList: [],
      queryInfo: {
        remindingUserName: '',
        createUserName: '',
        orderId: '',
        messageType: '',
        createTimeStart: '',
        createTimeEnd: '',
        status: '',
        remindingTitle: '',
        remindingContent: '',
        pageSize: 10,
        pageNum: 1
      },
      dateRangeValue: [],
      messageTypeOptions: [
        {
          value: '1',
          label: '订单消息'
        },
        {
          value: '3',
          label: '普通消息'
        },
        {
          value: '4',
          label: '订单修改'
        },
        {
          value: '5',
          label: '批次消息'
        },
        {
          value: "6",
          label: "不良消息",
        },
      ],
      messageList: [],
      total: 0,
      attachmentList: [],
      imgFileList: [],
      listObj: {},
    }
  },
  methods: {
    getMessageStatus(status){
      return this.messageStatusList[status]?.name || ''
    },
    getFileList(str) {
      if (str != null) {
        return str.split(",");
      }
      return []
    },
    getAttachment(str) {
      if (str != null && str.length > 0) {
        return JSON.parse(str);
      }
      return []
    },
    imgclick(url, visible) {
      this.visible = true
      this.imgurl = url
    },
    async handleDetail(row) {
      this.id = row.id
      const { data: res } = await this.$http.get('cmUser/message/queryMessageInfo/' + row.id);
      this.historyMessageList = res.data
      let arr = []
      res.data.forEach(item => {
        if (item.id == this.id) {
          arr.push(item)
        }
      })
      this.firstList = arr
      this.detailFlag = true
    },
    getMessageStatusList() {
      this.$http
          .get("/order/getNameList", { params: { nameClass: "MESSAGE_STATUS" } })
          .then((res) => {
            this.messageStatusList = res.data.data;
          });
    },
    async revoke(row) {
      this.$confirm("确定要撤回吗？", {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning"
      }).then(async () => {
        const { data: res } = await this.$http.post('cms/outBox/revoke', { id: row.id });
        if (res.code !== 200) {
          this.$message.error(res.message);
        } else {
          this.$message({
            type: "success",
            message: "撤回成功!"
          });
          await this.getMessageList();
          this.storeMessage(row);
        }
      }).catch(() => {
        this.$message({
          type: "info",
          message: "已退出操作"
        });
      });
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pageNum = newPage;
      this.getMessageList();
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getMessageList();
    },
    orderDateRange() {   //搜索时间

    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    searchList() {    //查询
      this.queryInfo.pageNum = 1;
      this.getMessageList();
    },
    async exportAction () {
      this.$http({
        url: '/cms/outBox/exportAction',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '发件箱列表.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    async getMessageList() {   //获取信息列表
      const { data: res } = await this.$http.get('cms/outBox/list', { params: this.queryInfo });
      res.data.list.forEach(item => {
        if (item.url) {
          item.url.split(',').forEach(citem => {
            if (item.remindingContent.includes(citem)) item.remindingContent = item.remindingContent.replace(citem, `<a href="${citem}" target="_blank">${citem}</a>`)
          })
        }
      })
      this.messageList = res.data.list;
      this.total = res.data.total;
    },
    queryInfoClear() {    //清空
      this.queryInfo = {
        remindingUserName: '',
        orderId: '',
        messageType: '',
        createTimeStart: '',
        createTimeEnd: '',
        status: 0,
        pageSize: 10,
        pageNum: 1
      }
      this.dateRangeValue = [];
    },
    typeDetailShow(status) {
      let statusStr = ''
      switch (status) {
        case "1":
          statusStr =  "订单消息";
          break;
        case "2":
          statusStr =  "其他消息";
          break;
        case "3":
          statusStr = "普通消息";
          break;
        case "4":
          statusStr = "订单修改";
          break;
        case "5":
          statusStr = "批次消息";
          break;
        case "6":
          statusStr = "不良消息";
          break;
      }
      return statusStr
    },
    toOrderDetail(row) {
      if (row.orderId.indexOf('P') != -1) { //P出现
        this.$router.push({     //装箱单
          name: 'container',
          query: {
            containerBatchNo: row.orderId
          }
        })
      } else {                  //订单详情
        this.$router.push({
          name: 'orderDetail',
          query: {
            id: row.orderId,
            isEdit: '0'
          }
        })
      }
    },
    storeMessage(row) {
      let key = []
      if (row.messagePid != undefined && row.messagePid != "") {
        key.push(`messageId_${row.messagePid}`)
      }

      if (row.remindingUserName != undefined && row.remindingUserName != "") {
        key.push(`userName_${row.remindingUserName}`)
      }

      if (row.orderId != undefined && row.orderId != "") {
        key.push(`orderNo_${row.orderId}`)
      }

      let messageKey = key.join('_');
      if (messageKey !== "") {

        if (row.attachment != '' && row.attachment != null) {
          localStorage.setItem(`messageAttachment_${messageKey}`, row.attachment)
        }

        if (row.replyPicture != '' && row.replyPicture != null) {
          let imgArr = []
          let imgList = row.replyPicture.split(',')
          for (let i = 0; i < imgList.length; i++) {
            imgArr.push({ name: 'img_' + i, url: imgList[i], hasSuccess: true, uid: Date.now() })
          }
          localStorage.setItem(`messageImg_${messageKey}`, JSON.stringify(imgArr))
        }

        if (row.remindingTitle != '' || row.remindingContent != '' || row.url != '') {
          localStorage.setItem(`message_${messageKey}`, JSON.stringify(row))
        }
      }
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    dateRangeValue() {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.dateRangeValue) {
        this.dateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.dateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.dateRangeValue[0];
          this.queryInfo.createTimeEnd = this.dateRangeValue[1];
        }
      }

    }
  },
  created() {
    this.getMessageList();
    this.getMessageStatusList();
  }
};
</script>

<style lang="less" scoped>
.role-page>.search-container {
  height: 60px !important;
}

.title {
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  margin: 15px 0;
}

.el-table .el-button--small {
  padding: 4px 10px;
}</style>
